import React from 'react'
import BodyClassName from 'react-body-classname'
import PropTypes from 'prop-types'

import Header from 'components/Header'
import Sidebar from 'components/Sidebar'
import GotoTop from 'components/GotoTop'

import 'assets/css/index.sass'

const Layout = props => (
  <BodyClassName className={props.sidebarData.bodyClass}>
    <div className="page-wrapper">
      <Header />
      <div className="clearfix" />
      <div className="page-container">
        <Sidebar pathname={props.location.pathname} />
        <div className="page-content-wrapper">
          {props.children}
        </div>
      </div>
      <GotoTop />
    </div>
  </BodyClassName>
)

Layout.defaultProps = {
  location: {
    pathname: '',
  },
  sidebarData: {
    bodyClass: '',
  },
}

Layout.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  sidebarData: PropTypes.shape({
    bodyClass: PropTypes.string.isRequired,
  }).isRequired,
  children: PropTypes.element.isRequired,
}

export default Layout
